
import "./RegGuidelines.css";

const RegGuidelines = () => {
  const guidelines = [
    {
      id: "01",
      title: "Prepare Your Documents",
      desc: "Ensure all necessary documents are ready and valid before starting the process.",
    },
    {
      id: "02",
      title: "Submit Applications Accurately",
      desc: "Fill forms carefully and provide correct information to avoid delays.",
    },
    {
      id: "03",
      title: "Track Your Progress",
      desc: "Use the tracking system to monitor the status of your application in real-time.",
    },
    {
      id: "04",
      title: "Stay Updated",
      desc: "Keep an eye on notifications for any additional requirements or approvals.",
    },
    {
      id: "05",
      title: "Follow Instructions",
      desc: "Adhere to official guidelines for submissions, appointments, or verifications.",
    },
    {
      id: "06",
      title: "Reach Out for Support",
      desc: "Contact customer service if you encounter issues or need clarification.",
    },
  ];

  return (
    <div className="container-fluid regMainGuidelines py-5">
      <div className="container">
        <div className="row align-items-start">
          {/* Left Text Section */}
          <div className="col-md-5">
            <div
              className="font-12 ff-semibold text-center glair-wrap bg-3 d-flex align-items-center gap-1 px-3 my-3 rounded-pill"
              style={{ width: "fit-content" }}
            >
              <img
                src="https://goodhand.b-cdn.net/Assets/Footer_pages/Amer/abt-tile-ico.svg"
                alt="icon"
              />
              <span className="ms-1 glair">Navigate with Assurance</span>
            </div>

            <h2 className="text-left font-25 text-black ff-bold mb-3">
              Navigate with Assurance
              <br />
              Quick Guidelines
            </h2>
          </div>

          {/* Right Guideline Cards */}
          <div className="col-md-7">
            <div className="row">
              {guidelines.map((item, idx) => (
                <div className="col-sm-6 " key={idx}>
                  <div className=" pb-3">
                    <p className="font-14 border-bottom pb-2 ff-bold text-black mb-1">
                      <span className=" me-2">
                        {item.id}. {item.title}
                      </span>
                    </p>

                    <p className="font-13 text-muted mb-0">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegGuidelines;
